import './Calendar.less'
import  Calendar  from './Calendar'

export type { CalendarRef } from './Calendar'
export type { CalendarProps } from './iCalendar'
export default Calendar
